import {
    AdvancedMarker,
    InfoWindow,
    Pin,
    useMap
} from "@vis.gl/react-google-maps";
import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { addressPlaceDetailsAtom } from "./analysisAtoms";

const AddressMarker = () => {
    const map = useMap();
    const [addressPlaceDetails] = useAtom(addressPlaceDetailsAtom);
    useEffect(() => {
        if (!map || !addressPlaceDetails) return;

        if (addressPlaceDetails.geometry?.viewport) {
            map.fitBounds(addressPlaceDetails.geometry?.viewport);
        }
    }, [map, addressPlaceDetails]);

    return (
        <>
            {addressPlaceDetails && (
                <AdvancedMarker
                    key={addressPlaceDetails?.id}
                    position={addressPlaceDetails.geometry.location}
                >
                    <Pin
                        background={"red"}
                        borderColor={"red"}
                        glyphColor="white"
                    />
                </AdvancedMarker>
            )}
        </>
    );
};

export default React.memo(AddressMarker);
